<template>
  <div class="toggle" :data-balloon="dataLabel" data-balloon-pos="down-right" @click.prevent="toggleNotification()">
    <span class="icon has-text-primary">
      <i v-if="!$isBroadcomMasters" :class="{'fal fa-bell-slash': !toggled, 'fal fa-bell': toggled}"></i>
    </span>
  </div>
</template>

<script>
import socket from '@/libs/socket'
import i18n from '@/i18n'
export default {
  props: ['conversation'],
  data: function () {
    return {
      toggled: this.conversation.notifications !== undefined ? this.conversation.notifications : true
    }
  },
  computed: {
    dataLabel: function () {
      return this.toggled ? i18n.t('messaging.notificationsOff') : i18n.t('messaging.notificationsOn')
    }
  },
  methods: {
    toggleNotification: function () {
      this.toggled = !this.toggled
      this.$store.dispatch('muteConversationForUser', { conversationID: this.conversation.id, notificiation: this.toggled })
      if (this.toggled) {
        socket.unsubscribe('conversation', this.conversation.id, 'message')
      } else {
        socket.subscribe('conversation', this.conversation.id, 'message')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .toggle {
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
